const exchangeRecordList = []

export default {
  exchangeRecordList
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/exchange-record/store/state.js